import { gql, useQuery } from "@apollo/client";

export const useActiveLibraryVideos = (categoryId?: string) => {
  return useQuery(gql`
    query getActiveLibraryVideos($filter: FilterFindManyLibraryVideoInput) { 
      library_videos_active_only(filter: $filter) {
        _id
        name
        description
        library_category_id
        video_id
      }
    }
  `, {
    variables: {
      filter: {
        library_category_id: categoryId,
      }
    },
    fetchPolicy: "network-only",
  });
};